export const environment = {
    production: true,
    // Usar ruta relativa para evitar CORS - nginx hará proxy a /api/ al backend
    apiUrl: '/api/xyz',
    deployUrl: '.'
};
